import { Link, useLocation } from "react-router-dom";
import HeaderBilingualLabel from "@/components/HeaderBilingualLabel";
import { openContactForm } from "@/lib/contactForm";
import { publicNavTo, visibleSiteNav } from "@/lib/publicNav";

function scrollToSection(sectionId) {
  document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
}

export default function HeaderNav() {
  const location = useLocation();

  const handleClick = (event, item) => {
    if (item.action === "contact") {
      event.preventDefault();
      openContactForm();
      return;
    }
    if (location.pathname === item.page && !item.sectionId) {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    if (item.sectionId && location.pathname === item.page) {
      event.preventDefault();
      scrollToSection(item.sectionId);
    }
  };

  return (
    <div className="ds-header-nav-links">
      {visibleSiteNav().map((item) => {
        const href = publicNavTo(item);
        return (
          <Link
            key={item.en}
            to={href}
            className="ds-header-nav-link"
            aria-label={item.ko}
            data-testid={item.action === "contact" ? "header-contact-cta" : undefined}
            onClick={(event) => handleClick(event, item)}
          >
            <HeaderBilingualLabel en={item.en} ko={item.ko} />
          </Link>
        );
      })}
    </div>
  );
}
